// @ts-strict-ignore
import { FC, useState } from 'react'

import { Popover } from '@/shared/ui/Popover'

import { TotalProductItem } from '../TotalProductItem/TotalProductItem'
import { TotalProductInfoProps } from '../TotalProductSetItem'

import cl from './total-popover-content.module.scss'

/**
 * Component for displayings a list of active services and accessories in the product card.
 * Displayed for desktop version.
 *
 * @param props
 * @param props.relatedItems - list of accessories and services
 * @param props.formattedPrice - total formatted price
 * @param props.totalText - Text with a summary of active products
 * @param props.onDeleteClick - Method for deleting an item
 *
 * */
export const TotalPopoverContent: FC<TotalProductInfoProps> = ({
	relatedItems,
	onDeleteClick,
	totalText,
	formattedPrice,
	hidePrice
}) => {
	const [visible, setVisible] = useState(false)

	const hide = (): void => {
		setVisible(false)
	}

	const handleVisibleChange = (newVisible: boolean): void => {
		setVisible(newVisible)
	}

	const popoverContent = (
		<>
			<ul className={cl.totalPopoverContent}>
				{relatedItems.map(item => (
					<TotalProductItem {...item} key={item.ID} onClick={onDeleteClick} />
				))}
				<button className={cl.totalPopoverContent__closeButton} onClick={hide}>
					Закрыть
				</button>
			</ul>
		</>
	)

	return (
		<>
			<Popover
				content={popoverContent}
				placement="bottomLeft"
				title="Добавленные услуги"
				trigger="click"
				open={visible}
				overlayClassName="servicesList"
				onOpenChange={handleVisibleChange}
				overlayInnerStyle={{
					padding: `18px 16px`,
					borderRadius: `12px`
				}}>
				<button className={cl.totalPopoverContent__button}>{totalText}&thinsp;</button>
			</Popover>
			{!hidePrice && `на ${formattedPrice}`}
		</>
	)
}
